import { render, staticRenderFns } from "./TypeTwoIntro.vue?vue&type=template&id=3d1aaea3&scoped=true"
import script from "./TypeTwoIntro.vue?vue&type=script&lang=js"
export * from "./TypeTwoIntro.vue?vue&type=script&lang=js"
import style0 from "./TypeTwoIntro.vue?vue&type=style&index=0&id=3d1aaea3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1aaea3",
  null
  
)

export default component.exports